// STATE 
export const updatePost = false

// REDUCER
export const UpdatePostReducer = (state, action) => {
    switch (action.type) {
        case 'updateThePostAfterUploading':
            return true
        case 'updateThePostAfterDeleting':
            return true
        case 'changeToDefaultState':
            return false
        default:
            return updatePost
    }
}